import { useContext } from 'react';
import { AuthContext } from './authContext';

export const useAuthManager = () => {
  return useContext(AuthContext);
};
